/**
 * Analytics handlers for new BFF API spec
 */

import { http, HttpResponse } from 'msw'
import { generateAnalyticsSummary, generateApprovalRateDashboard } from '../data/analytics'
import { applyDelay } from '../utils/delays'

export const analyticsHandlers = [
  /**
   * GET /api/bff/merchant/analytics/summary
   * Summary statistics with volumes, rankings, and analyses
   */
  http.get('/api/bff/merchant/analytics/summary', async ({ request }) => {
    const url = new URL(request.url)
    const searchParams = url.searchParams

    // Apply delay simulation
    await applyDelay({ searchParams, preset: 'fast' })

    const dateStart = searchParams.get('date_start') || undefined
    const dateEnd = searchParams.get('date_end') || undefined

    const summary = generateAnalyticsSummary(dateStart, dateEnd)

    return HttpResponse.json(summary)
  }),

  /**
   * GET /api/bff/merchant/analytics/approval-rate
   * Approval rate dashboard with metrics, trends, and comparisons
   */
  http.get('/api/bff/merchant/analytics/approval-rate', async ({ request }) => {
    const url = new URL(request.url)
    const searchParams = url.searchParams

    // Apply delay simulation
    await applyDelay({ searchParams, preset: 'fast' })

    const dateStart = searchParams.get('date_start') || undefined
    const dateEnd = searchParams.get('date_end') || undefined
    const onlyApprovalRate = searchParams.get('only_approval_rate') === 'true'

    const data = generateApprovalRateDashboard(dateStart, dateEnd, onlyApprovalRate)

    return HttpResponse.json(data)
  })
]
